import React, {Component, Fragment} from 'react';
import queryString from 'query-string';

import * as Constant from '@app/Constant.js';

import DatePicker from "react-datepicker";


import PieChart from '@app/components/PieChart';

import { Link } from "react-router-dom";

import Accodion from '@app/components/Accodion';
import RouteTitle from '@app/components/RouteTitle';
import Spinner from '@app/components/Spinner';

import axios from '@app/lib/axios';

const CustomDatepicker = ({ value, onClick }) => {
    return (
        <div className="input-group mb-3">
            <div className="input-group-append">
                <button type="button" className="btn btn-primary" onClick={onClick}><i className="fas fa-calendar-alt"></i></button>
            </div>
        </div>
    )
};


class CsListView extends Component {
    render() {
        if(this.props.csList) {
            return (
                <Fragment>
                {
                    
                        this.props.csList.map(data => {
                            var titleColor = data.is_issue == 'Y' || data.is_complete == 'N' ? "red" : "black";
                            return (
                                <div className="card-body border-bottom p-3">
                                    <div className="review-block">

                                        <div className="text-dark font-weight-bold">
                                            <a href={"/csForm?id="+data.id} style={{color : titleColor }} >{data.question}</a>
                                            {data.is_issue == 'Y' ? <span className="float-right badge badge-secondary mr-1 mr-1"><i className="fas fa-exclamation-circle"></i> issue</span>  : ""}
                                            {data.is_complete == 'N' ? <span className="float-right badge badge-danger mr-1 mr-1"><i className="fas fa-question-circle"></i> waiting</span> : ""}
                                        </div>
                                        <p className="review-text mt-1">
                                            <i className="fas fa-arrow-alt-circle-right"></i>&nbsp;&nbsp;&nbsp;
                                            {data.answer}
                                        </p>
                                        
                                    </div>
                                </div>
                            )
                        })          
                    
                }
                </Fragment>
            );
        } else {
            return(
                <div className="card-body border-bottom mb-4">
                    <div className="review-block">
                        <span className="text-dark font-weight-bold">
                            데이터가 존재하지 않습니다.
                        </span>
                    </div>
                </div>
            );
        }
        
    }
    
};

class CsWeekly extends Component {

    constructor(props) {
        super(props);
        const query =  queryString.parse(this.props.location.search);

        this.state = {
            products: [],
            product : query.product,
            productName : "",
            typeMap : {},
            typeList : [],
            list : [],
            monday : "",
            friday : "",
            baseDate : new Date(),
            isLoaded : false,
            weekToString : "loading...",
            pieData : []
        }
    }

    componentWillReceiveProps = (nextProps) => {
    }

    getProduct = () => {
        var url = Constant.API_DOMAIN + "/api/cs_info/init/0";
        axios({
            method: "get",
            url: url,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    this.setState({
                        products: result.data.products,
                    }, () => {
                        var queryStr = this.props.location.search;
                        var queryObj = queryString.parse(queryStr);
                        var today = null;
                        if(queryObj.date) {
                            today = new Date(queryObj.date);
                        } else {
                            today = new Date();
                        }
                        this.getWeeklyData(today, result.data.products[0].name);        
                    });
                } else {
                    alert(result.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    getWeeklyData = (datePram, product) => {
        if (!product) product = "토모노트";
        var date = this.state.baseDate;
        if(datePram) {
            date = new Date(datePram);
            this.setState ({
                baseDate : date
            });
        }

        var dateStr = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        if(this.state.listLoaded) {
            this.setState({
                listLoaded: false
            });
        }


        axios({
          method: "get",
          url:  Constant.API_DOMAIN + "/api/stat/weekly/"+dateStr + "?product="+product
        })
          .then(result => {
            if(result.data.code === 200) {  

                var types = {};

                result.data.list.map(data => {
                    var typeArr = types[data.type_code];
                    if(!typeArr) typeArr = [];

                    typeArr.push(data);

                    types[data.type_code] = typeArr;
                });

                var total = 0;
                var num = 0;
                result.data.type.map(type => {
                    if(types[type.id] && types[type.id].length) {
                        total += types[type.id].length;
                        num++;
                    }
                });
                var average = total / num;
                
                
                var pieData = [];
                
                result.data.type.map(type => {
                    
                    pieData.push({
                        "id": type.id,
                        "label": type.name,
                        "value": types[type.id] != null ? types[type.id].length : 0
                    });

                    if(types[type.id] && types[type.id].length) {
                        


                        if(average < types[type.id].length) {
                            type.status = "secondary";
                        }else {
                           type.status = "success";
                        }

                        var dataList = types[type.id];
                        if(dataList) {
                            var issueList = [];
                            var waitingNum = 0;
                            types[type.id].map(csData => {
                                if(csData.is_issue == 'Y') {
                                    issueList.push(csData);
                                }
                                if(csData.is_complete == 'N') {
                                    waitingNum++;
                                }
                            });

                            type.issueList = issueList;
                        } else {
                            dataList = [];
                        }

                        type.list = dataList;
                        


                    } else {
                        type.status = "info";
                    }
                });

                    this.setState(
                        {
                            productName: result.data.product_name,
                            typeList: result.data.type,
                            list: result.data.list,
                            isLoaded: true,
                            weekToString: result.data.weekToString,
                            monday: Number(result.data.monday),
                            friday: Number(result.data.friday),
                            pieData: pieData,
                        },
                        () => {
                            // this.props.history.replace(undefined, { ...this.state });
                        }
                    );
                } else {
                    this.setState({
                        isLoaded: true,
                    });
                    alert(result.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });


        this.setState({
            isLoaded : true
        });
    }


    handleDateChange = (date) => {
        this.setState({
            baseDate : date
        });
        this.getWeeklyData(date, this.state.product);
    }


    componentDidMount(){
        this.getProduct();  
    };
    
    tabClick = (e) => {
        e.preventDefault();
    };

    serviceChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        this.setState(
            {
                product: value,
            },
            function () {
                this.getWeeklyData(null, value);
            }
        );
    };

    ListOrderSelect = ({type}) => {
        return(
            <select className="custom-select ml-auto w-auto" onChange={this.changeListOrder}>
                <option value={type + "_issue"}>이슈</option>
                <option value={type + "_waiting"}>미처리</option>
                <option value={type + "_requestDate"}>요청일</option>
            </select>
        )
    }

    changeListOrder = (e) => {
        e.preventDefault();

        var typeId = e.target.value.split("_")[0];
        var order = e.target.value.split("_")[1];

        if(typeId === "all") {
            var list = this.state.list;
            list = list.sort( (a, b) => {
                if("issue" === order) {
                    return (b.is_issue === 'Y' ? 1 : 0) - (a.is_issue === 'Y' ? 1 : 0);
                } else if("waiting" === order) {
                    return (b.is_complete === 'N' ? 1 : 0) - (a.is_complete === 'N' ? 1 : 0);
                } else {
                    return new Date(b.request_date) - new Date(a.request_date);
                }
            });
            this.setState({
                list : list
            });
        } else {
            var typeList = this.state.typeList;
            typeList.forEach(type => {
                if(type.id == typeId && type.list) {
                    type.list = type.list.sort( (a, b) => {
                        console.log(a);
                        console.log(b);
                        if("issue" === order) {
                            return (a.is_issue === 'Y' ? 1 : 0) - (b.is_issue === 'Y' ? 1 : 0);
                        } else if("waiting" === order) {
                            return (a.is_complete === 'N' ? 1 : 0) - (b.is_complete === 'Y' ? 1 : 0);
                        } else {
                            return new Date(b.request_date) - new Date(a.request_date);
                        }
                    });
                }
                
            });

            this.setState({
                typeList : typeList
            })

        }
    };

    render() {
        const {products} = this.state;

        if (this.state.isLoaded) {
            return (
                <div className="dashboard-wrapper">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12">
                                <h2>{this.state.productName + " 주간 CS 리포트"}</h2>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 float-right">
                                <select className="form-control form-control-lg" name="service" value={this.state.productName} onChange={this.serviceChange} style={{ fontSize: "1.3em" }}>
                                    {products.map((s) => (
                                        <option selected={this.state.productName == s.name ? true : false}>{s.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid dashboard-content">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-5 col-sm-12 col-12">
                        
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                                <h2 className="font-24 mb-0">{this.state.weekToString}</h2>
                                                <p>{this.state.monday}일 ~ {this.state.friday}일</p>
                                            </div>
                                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                                <div className="float-right">
                                                     <DatePicker
                                                        className="float-right"
                                                        name="searchDate"
                                                        selected={this.state.baseDate}
                                                        onChange={this.handleDateChange}
                                                        customInput={<CustomDatepicker />}
                                                        dateFormat="yyyy-MM-dd"
                                                      />
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="user-avatar text-center d-block" style={{height : "300px"}}>
                                            <PieChart data={this.state.pieData}/>
                                        </div>
                                    </div>
                                    <div className="card-body border-top">
                                        <h3 className="font-16">문의 유형별 CS 접수 사례</h3>
                                        <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                            <a className="nav-link active border-top" id={"type_all"} data-toggle="pill" href={"#type_all_tabContent"} onClick={this.tabClick} role="tab" aria-controls={"type_all_tabContent"} >
                                                전체
                                                 <span className={"float-right badge ml-1  badge-warning"} style={{minWidth : "30px", textAlign:"center"}}>{this.state.list.length}</span>
                                            </a>
                                            {
                                                this.state.typeList.map(type => {
                                                   return ( 
                                                            <a className="nav-link border-top" id={"type_" + type.id} data-toggle="pill" href={"#type_" + type.id + "_tabContent"} role="tab" aria-controls={"type_" + type.id + "_tabContent"}  aria-selected="false">
                                                                {type.name}
                                                                 <span className={"float-right badge ml-1  badge-"+type.status} style={{minWidth : "30px", textAlign:"center"}}
                                                                    data-toggle="tooltip" data-placement="left" data-original-title="tooltip here"
                                                                 >{type.list ? type.list.length : "0"}</span>
                                                            </a>

                                                    )
                                                })
                                            }
                                        </div>  
                                    </div>
                                </div>
                                
                            </div>


                            <div className="col-xl-8 col-lg-8 col-md-7 col-sm-12 col-12 ">
                                <div className="pills-vertical">
                                    <div className="tab-content" id="v-pills-tabContent">
                                        <div className="tab-pane active show" id="type_all_tabContent" role="tabpanel" aria-labelledby="type_all">

                                            <div className="card">
                                                <div className="card-header d-flex bg-primary">
                                                    <h4 className="card-header-title bg-primary">"전체" 문의</h4>
                                                    <this.ListOrderSelect type="all"/>
                                                </div>
                                               
                                                <CsListView csList={this.state.list}/>
                                            </div>
                                        </div>
                                        {
                                            this.state.typeList.map(type => {
                                               return (
                                                        <div className="tab-pane fade " id={"type_" + type.id + "_tabContent"} role="tabpanel" aria-labelledby={"type_" + type.id }>

                                                            <div className="card">
                                                                <div className="card-header d-flex bg-primary">
                                                                    <h4 className="card-header-title bg-primary">"{type.name}" 문의</h4>
                                                                    <this.ListOrderSelect type={type.id}/>
                                                                </div>

                                                                <CsListView csList={type.list}/>

                                                            </div>
                                                        </div>
                                                       
                                                )
                                            })
                                        }
                                        
                                        
                                    </div>
                                </div>
                            </div>
                            

                            

                        </div>
                    </div>
                </div>
                
            )
        }else {
            return (
                <Spinner/>
            )
        }
        
    }

}


export default CsWeekly;


